export default async function getRegistrosEventos() {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 15000);

  try {
    const url = `${process.env.REACT_APP_MICROSERVICO_IP}/cmd/events`;
    const res = await fetch(url, { signal: controller.signal });

    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const json = await res.json();

    // Garante formato sempre igual
    return {
      success: Boolean(json?.success),
      data: Array.isArray(json?.data) ? json.data : [],
      count: json?.count ?? 0,
      total: json?.total ?? 0,
      filters: json?.filters ?? {}
    };
  } catch (err) {
    console.error("getRegistrosEventos erro:", err?.message || err);
    return { success: false, data: [], count: 0, total: 0, filters: {} };
  } finally {
    clearTimeout(timeout);
  }
}